module.exports = __webpack_public_path__ + "static/img/third1_1.e8344e39.png";